"use client";

import type { ReactNode } from "react";
import { usePathname } from "next/navigation";

import { isHireCandidateRoute } from "@/lib/full-viewport-routes";

/**
 * `HR-JOB01d`: the site-wide third-party tags (the Meta Pixel, Chokh and the
 * Cloudflare beacon, `app/root-document.tsx`) on every page but a Hire
 * candidate's test page, which loads no advertising pixel and no analytics at
 * all (`docs/37` §6, "No tracking on candidate pages").
 *
 * The decision is the path's, so the server HTML of that page carries none of
 * the tags (and none of their preloads) and nothing has to be unloaded later.
 * Everywhere else the children render exactly as the root document wrote them.
 */
export function ThirdPartyTagsGate({ children }: { children: ReactNode }) {
  const pathname = usePathname() ?? "";
  if (isHireCandidateRoute(pathname)) return null;
  return <>{children}</>;
}
